export function getLicenseTypes(account, formData) {
  if (formData.industries && account.industries) {
    const industries = formData.industries.filter(({ id }) =>
      account.industries.includes(id)
    );
    return industries
      .reduce((licenseTypes, industry) => {
        return licenseTypes.concat(industry.licenseTypes);
      }, [])
      .sort((a, b) => a.name - b.name);
  }
  return [];
}
